import { useCallback, useEffect, useState } from 'react';
import { Durchfuehrungszeitraum } from '../../../types';
import { durchfuehrungszeitraeumeService } from '../../../services/durchfuehrungszeitraeumeService';

export const useAuditZeitraeume = (auditId: number | null) => {
  const [zeitraeume, setZeitraeume] = useState<Durchfuehrungszeitraum[]>([]);
  const [loadingZeitraeume, setLoadingZeitraeume] = useState(false);

  const loadZeitraeume = useCallback(async () => {
    if (!auditId) return;

    try {
      setLoadingZeitraeume(true);
      const data = await durchfuehrungszeitraeumeService.list({ audit_id: auditId });
      setZeitraeume(data);
    } catch (error) {
      console.error('Fehler beim Laden der Zeitraeume:', error);
    } finally {
      setLoadingZeitraeume(false);
    }
  }, [auditId]);

  useEffect(() => {
    void loadZeitraeume();
  }, [loadZeitraeume]);

  return {
    zeitraeume,
    setZeitraeume,
    loadingZeitraeume,
    loadZeitraeume,
  };
};
